.iconBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-inline: var(--sp-3);
}

/* Крупная кнопка панели сравнения: единственное действие панели, поэтому она
   во всю её ширину и с подписью. Цвет — тот же голубой, которым в интерфейсе
   помечены перелёты и ссылки: это приглашение отдать поездку наружу, а не
   разрушительное действие, поэтому обводка, а не заливка. */
.wideWrap {
  display: block;
}

button.wideBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--sp-3);
  width: 100%;
  padding: var(--sp-4) var(--sp-5);
  border-color: var(--flight);
  color: var(--flight);
  font-size: var(--fs-md);
  font-weight: 600;
}

button.wideBtn:hover {
  background: var(--flight);
  border-color: var(--flight);
  color: var(--btn-primary-fg);
}

.body {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
  min-width: min(400px, 76vw);
}

.hint {
  margin: 0;
  font-size: var(--fs-sm);
  color: var(--text-3);
  line-height: 1.4;
}

.meta {
  margin: 0;
  font-size: var(--fs-xs);
  color: var(--text-3);
}

.error {
  margin: 0;
  padding: var(--sp-4) var(--sp-5);
  border: var(--bw) solid var(--error-border);
  border-radius: var(--radius);
  background: var(--error-bg);
  color: var(--error);
  font-size: var(--fs-sm);
}

.linkRow {
  display: flex;
  gap: var(--sp-4);
}

.linkRow .input {
  flex: 1;
  min-width: 0;
  font-size: var(--fs-sm);
}

.actions {
  display: flex;
  gap: var(--sp-4);
}
